import { render, staticRenderFns } from "./AdminProfilePasswordModal.vue?vue&type=template&id=0ea8caf0&scoped=true"
import script from "./AdminProfilePasswordModal.vue?vue&type=script&lang=js"
export * from "./AdminProfilePasswordModal.vue?vue&type=script&lang=js"
import style0 from "./AdminProfilePasswordModal.vue?vue&type=style&index=0&id=0ea8caf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea8caf0",
  null
  
)

export default component.exports